import axiosInstance from "./axiosInstance.js";
import { store } from "./redux/store.js";

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().authTeacher.teacherToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔁 Обновление accessToken при 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isRefreshRequest = originalRequest.url.includes("/refresh");

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isRefreshRequest
    ) {
      originalRequest._retry = true;
      try {
        const refreshResponse = await axiosInstance.post("/teacher/refresh");
        const teacherToken = refreshResponse.data.teacherToken;

        store.dispatch({
          type: "authTeacher/refresh/fulfilled",
          payload: { teacherToken },
        });

        originalRequest.headers["Authorization"] = `Bearer ${teacherToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        store.dispatch({ type: "authTeacher/logout/fulfilled" });
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
